import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faDatabase, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const DonaQRMyDonations = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [donaQRs, setDonaQRs] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedDonaQRId, setSelectedDonaQRId] = useState(null);

  const fetchDonaQRs = useCallback(() => {
    const config = { url: "/donaqrs", method: "get", headers: { Authorization: authState.token } };
    fetchData(config, { showSuccessToast: false })
      .then(data => {
        // console.log("Response:", data); // Log the entire response object
        setDonaQRs(data);
      })
      .catch(error => console.error("Error fetching DonaQRs:", error));
  }, [authState.token, fetchData]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchDonaQRs();
  }, [authState.isLoggedIn, fetchDonaQRs]);

  if (loading) {
    return <Loader />;
  }

  const handleView = (donaQRId) => {
    setSelectedDonaQRId(prevId => (prevId === donaQRId ? null : donaQRId));
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleSearch = () => {
    // Implement search functionality
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateTime = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleRefresh = () => {
    fetchDonaQRs();
  };

  return (
    <div className="my-2 mx-auto max-w-[700px] py-4">
      {/* {loading ? <Loader /> : (
        <> */}
      {donaQRs.length !== 0 && (
        <div className="search-container">
          {/* Search inputs */}
        </div>
      )}

      <div className="list-container border border-gray-300 p-4 mt-4">
        {/* DonaQR list */}
        <div className="flex justify-between items-center mt-2">
          <div className='w-full h-full px-1 py-2 ml-1 mr-4 flex items-center'>
            <Tooltip text={"Refresh Data"} position={"top"}>
              <FontAwesomeIcon icon={faDatabase} className="cursor-pointer text-white mr-2" onClick={handleRefresh} />
            </Tooltip>
            {donaQRs.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-white'>Your QR Codes ({donaQRs.length})</h2>}
            {donaQRs.length === 0 && <h2 className='my-2 ml-2 md:ml-0 text-white'>Your QR Codes</h2>}
          </div>
          <div className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md w-full">
            <Link to='/donaqrs/add' className='block w-full h-full px-1 py-2 ml-4 mr-4'>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '10px' }} />  Get New QR Code
            </Link>
          </div>
        </div>

        {donaQRs.length === 0 ? (
          <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
            <span>No record found</span>
          </div>
        ) : (
          <div>
            {donaQRs.map((donaQR, index) => (
              <div key={donaQR._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium'>#{index + 1} ({formatDate(donaQR.donaqrStartDate)})</span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(donaQR._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
                </div>
                <div className='whitespace-pre  text-blue-700'>{donaQR.donaqrTitle}</div>
                {selectedDonaQRId === donaQR._id && (
                  <div className='bg-gray-200 text-black'>
                    <h2 className='text-blue-600'><strong>DonaQR Details</strong></h2>
                    <p><strong>_id:</strong> {donaQR._id}</p>
                    <p><strong>Owner ID:</strong> {donaQR.donaqrOwner}</p>
                    <p><strong>Owner Name:</strong> {donaQR.donaqrOwnerName}</p>
                    <p><strong>Accessors:</strong></p>
                    <div key="accessors" className="ml-8 text-blue-800">
                      {donaQR.donaqrAccessors.map(accessor => accessor.accessorName).join(', ')}
                    </div>
                    <p><strong>Partner:</strong></p>
                    {Array.isArray(donaQR.donaqrPartner) && donaQR.donaqrPartner.map((partner, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>ID:</strong> {partner.partnerID}</p>
                        <p><strong>Name:</strong> {partner.partnerName}</p>
                      </div>
                    ))}
                    <p><strong>Access Dates:</strong></p>
                    {Array.isArray(donaQR.donaqrDetailsAccessDate) && donaQR.donaqrDetailsAccessDate.map((accessdate, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>ID:</strong> {accessdate.userID}</p>
                        <p><strong>DateTime:</strong> {formatDateTime(accessdate.accessDateTime)}</p>
                      </div>
                    ))}
                    <p><strong>Title:</strong> {donaQR.donaqrTitle}</p>
                    <p><strong>Is a Campaign:</strong> {donaQR.donaqrIsCampaign}</p>
                    <p><strong>Purpose:</strong> {donaQR.donaqrPurpose}</p>
                    <p><strong>Beneficiary Name:</strong> {donaQR.donaqrBen}</p>
                    <p><strong>Beneficiary Contact Details:</strong> {donaQR.donaqrBenAddress}</p>
                    <p><strong>Month & Year:</strong> {donaQR.donaqrMonthYear}</p>
                    <p><strong>Start Date:</strong> {donaQR.donaqrStartDate}</p>
                    <p><strong>Has End Date?:</strong> {donaQR.donaqrHasEndDate}</p>
                    <p><strong>EndDate:</strong> {donaQR.donaqrEndDate}</p>
                    <p><strong>Campaign Days:</strong> {donaQR.donaqrCampaignDays}</p>
                    <p><strong>Target Amount:</strong> {donaQR.donaqrTargetAmount}</p>
                    <p><strong>Has Banner?:</strong> {donaQR.donaqrHasBanner}</p>
                    <p><strong>Banner File Name:</strong> {donaQR.donaqrBannerFileName}</p>
                    <p><strong>Banner Path Name:</strong> {donaQR.donaqrBannerPathName}</p>
                    <p><strong>PAN Details:</strong> {donaQR.donaqrPANDetails}</p>
                    <p><strong>Bank Details:</strong> {donaQR.donaqrBankDetails}</p>
                    <p><strong>Show Income/Expenditure:</strong> {donaQR.donaqrShowAccounting}</p>
                    <p><strong>Income/Expenditure:</strong></p>
                    {Array.isArray(donaQR.donaqrAccounting) && (
                      <table className="table-auto w-full">
                        <thead className="bg-gray-500">
                          <tr>
                            <th className="px-2 py-0 text-left">Group</th>
                            <th className="px-2 py-0 text-left">Head</th>
                            <th className="px-2 py-0 text-left">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {donaQR.donaqrAccounting.map((item, index) => (
                            <tr key={index} className="text-blue-800">
                              <td className="border px-2 py-0 text-left">{item.group}</td>
                              <td className="border px-2 py-0 text-left">{item.head}</td>
                              <td className="border px-2 py-0 text-left">{item.amount.toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    <p><strong>Auditor Name:</strong> {donaQR.donaqrAuditorName}</p>
                    <p><strong>Verification:</strong></p>
                    <div className="ml-8 text-blue-800">
                      <p><strong>Is Verified:</strong> {donaQR.donaqrIsVerified}</p>
                      <p><strong>Verification Date:</strong> {donaQR.donaqrVerificationDate}</p>
                      <p><strong>Verifier ID:</strong> {donaQR.verifierID}</p>
                      <p><strong>Verifier Name:</strong> {donaQR.donaqrVerifierName}</p>
                      <p><strong>Verified Date:</strong> {donaQR.donaqrVerifiedDate}</p>
                    </div>
                    <p><strong>Is Active:</strong> {donaQR.donaqrIsActive}</p>
                    <p><strong>Is Deleted:</strong> {donaQR.donaqrIsDeleted}</p>
                    <p><strong>Date Created:</strong> {donaQR.donaqrDateCreated}</p>

                    <p><strong>Is Encrypted:</strong> {donaQR.donaqrIsEncrypted}</p>
                    <p><strong>Encryption Key:</strong> {donaQR.donaqrEncryptionKey}</p>
                    <p><strong>QR Text:</strong> {donaQR.donaQRText}</p>
                    <p><strong>Donors List:</strong></p>
                    <div className="overflow-x-auto">
                      <table className="table-auto min-w-full">
                        <thead className="bg-gray-500 text-white">
                          <tr>
                            <th className="px-4 py-2 text-left" rowSpan="2">Donor</th>
                            <th className="px-4 py-2 text-left" colSpan="3">Contact</th>
                            <th className="px-4 py-2 text-left" colSpan="3">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(donaQR.donaqrDonors) && donaQR.donaqrDonors.map((donor, index) => (
                            <React.Fragment key={index}>
                              <tr key={index} className="text-blue-800 align-text-top">
                                <td className="border px-4 py-2" rowSpan="3">
                                    {donor.donorID}
                                    {donor.name}
                                </td>
                                <td className="border px-4 py-2">
                                    {donor.city}
                                    {donor.mobileNumber}
                                    {donor.emailID}
                                </td>
                                <td className="border px-4 py-2">
                                    {donor.donationAmount.toFixed(2)}
                                    {formatDateTime(donor.donationDate)}
                                    {donor.receiptNumber}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <p><strong>Remittances:</strong></p>
                    {Array.isArray(donaQR.donaqrRemittances) && donaQR.donaqrRemittances.map((remittance, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>Date:</strong> {remittance.remitDate}</p>
                        <p><strong>Period Start Date:</strong> {remittance.remitPeriodStartDate}</p>
                        <p><strong>Period End Date:</strong> {remittance.remitPeriodEndDate}</p>
                        <p><strong>Amount:</strong> {remittance.remitAmount}</p>
                        <p><strong>Remarks:</strong> {remittance.remitRemarks}</p>
                      </div>
                    ))}
                    <p><strong>Incentive Payments:</strong></p>
                    {Array.isArray(donaQR.donaqrIncentivePayments) && donaQR.donaqrIncentivePayments.map((payment, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>Pay Date:</strong> {payment.incentivePayDate}</p>
                        <p><strong>Period Start Date:</strong> {payment.incentivePeriodStartDate}</p>
                        <p><strong>Period End Date:</strong> {payment.incentivePeriodEndDate}</p>
                        <p><strong>Amount:</strong> {payment.incentiveAmount}</p>
                        <p><strong>Remarks:</strong> {payment.incentiveRemarks}</p>
                      </div>
                    ))}
                    <p><strong>Tax Details:</strong></p>
                    {donaQR.donaqrTaxDetails.map((taxDetail, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>Type:</strong> {taxDetail.taxType}</p>
                        <p><strong>Pay Date:</strong> {taxDetail.taxPayDate}</p>
                        <p><strong>Period Start Date:</strong> {taxDetail.taxPeriodStartDate}</p>
                        <p><strong>Period End Date:</strong> {taxDetail.taxPeriodEndDate}</p>
                        <p><strong>Amount:</strong> {taxDetail.taxAmount}</p>
                        <p><strong>Remarks:</strong> {taxDetail.taxRemarks}</p>
                        <p><strong>Deductor Account Number:</strong> {taxDetail.deductorAccount}</p>
                        <p><strong>Depositor Account Number:</strong> {taxDetail.depositorAccount}</p>
                      </div>
                    ))}
                    <p><strong>QR Code Generation:</strong></p>
                    <div className="ml-8 text-blue-800">
                      <p><strong>Cost:</strong> {donaQR.donaqrGenCost}</p>
                      <p><strong>Cost Type:</strong> {donaQR.donaqrGenCostType}</p>
                      <p><strong>Cost Currency:</strong> {donaQR.donaqrGenCostCurrency}</p>
                    </div>
                    <p><strong>QR Code Scan:</strong></p>
                    <div className="ml-8 text-blue-800">
                      <p><strong>Cost:</strong> {donaQR.donaqrScanCost}</p>
                      <p><strong>Cost Type:</strong> {donaQR.donaqrScanCostType}</p>
                      <p><strong>Cost Currency:</strong> {donaQR.donaqrScanCostCurrency}</p>
                    </div>
                    <p><strong>Current Balance:</strong> {donaQR.donaqrCurrentBalance}</p>
                    <p><strong>Recharge History:</strong></p>
                    {Array.isArray(donaQR.donaqrRechargeHistory) && donaQR.donaqrRechargeHistory.map((rechargehistory, index) => (
                      <div className="ml-8 text-blue-800">
                        <p><strong>Date:</strong> {rechargehistory.rechargeDate}</p>
                        <p><strong>Amount:</strong> {rechargehistory.rechargeAmount}</p>
                        <p><strong>Currency:</strong> {rechargehistory.rechargeCurrency}</p>
                        <p><strong>Remarks:</strong> {rechargehistory.rechargeRemarks}</p>
                        <p><strong>Receipt Number:</strong> {rechargehistory.rechargeReceiptNumber}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      {/* </>
      )} */}
    </div>
  );
};

export default DonaQRMyDonations;
